import { S3Client } from "@aws-sdk/client-s3";
import { getAwsServiceClientConfig } from "./oauth/login-data";

export function createS3Client(): S3Client {
  return new S3Client(getAwsServiceClientConfig());
}